
import { createApi } from '@reduxjs/toolkit/query/react';

import { customFetchBase } from '../../utils/authentication/fetchBaseQuery';
import { transformErrorResponse, transformSuccessResponse } from '../../utils/middleware/responseMiddleware';

export const commonApi = createApi({

    reducerPath: 'commonApi',
    baseQuery: customFetchBase,

    endpoints: (builder) => ({

        getGridData: builder.query({
            query: function (params) {
                const { url } = params;

                return {
                    url: url,
                    params: { data: JSON.stringify(params?.params) }
                };
            }
        }),

        getDropdownData: builder.query({
            query: function (params) {
                return {
                    url: params.url,
                    params: params.params
                }
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        postGridData: builder.mutation({
            query: function (params) {
                const { url } = params;
                let { first, rows, sortField, sortOrder, ...retVal } = params.params;

                retVal.pageIndex = (first / rows);
                retVal.pageSize = rows;

                if (sortField) {
                    retVal.sortField = sortField;
                    retVal.sortDesc = sortOrder < 0;
                }

                return {
                    url: url,
                    body: retVal,
                    method: 'POST'
                };
            },
            // transformResponse: transformSuccessResponse,
            // transformErrorResponse: transformErrorResponse
        }),

        getData: builder.query({
            query: (params) => {
                const urlSearchParams = new URLSearchParams(params.data);
                const queryString = urlSearchParams.toString();
                return {
                    url: `${params.url}?${queryString}`
                }
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteData: builder.mutation({
            query: (params) => {
                const urlSearchParams = new URLSearchParams(params.data);
                const queryString = urlSearchParams.toString();
                return {
                    url: `${params.url}?${queryString}`,
                    method: "DELETE"
                }
            },
        }),

        //Use this when file needs to upload along with data
        postFormData: builder.mutation({
            query: (params) => {
                const obj = params.data;

                const formData = new FormData();
                for (const key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        let o = obj[key];
                        if (o instanceof Array && o.length > 0 && o[0] instanceof File) {
                            o.forEach(f => formData.append(key, f));
                        }
                        else {
                            formData.append(key, o);
                        }
                    }
                }

                return {
                    url: params.url,
                    body: formData,
                    method: 'POST'
                };
            }
        }),

        //Use this without file. only data needs to post
        postData: builder.mutation({
            query: (params) => {
                return {
                    url: params.url,
                    body: params.data,
                    method: 'POST'
                };
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        })
    }),
});

export const {
    useGetGridDataQuery,
    useLazyGetDropdownDataQuery,
    useLazyGetGridDataQuery,
    usePostGridDataMutation,
    useLazyGetDataQuery,
    // useDeleteDataQuery,
    useDeleteDataMutation,
    usePostFormDataMutation,
    usePostDataMutation
} = commonApi;
